<template lang="pug">
  v-container
    v-btn(@click="onClickReset") Lancer la réinitialisation
</template>

<script>
import { ref } from '@vue/composition-api'
import { page } from '@iez/core'
import resetSeed from '@/seed/'

window.resetSeed = resetSeed

const route = {
  name: `ManageDataSeed`,
  path: `/manage-data-seed/`
}

export default {
  ...route,

  setup () {
    const isLoading = ref(false)

    page.topBar.set({
      title: `Remise des données initiales`
    })

    page.blockingProgression.set(
      () => isLoading.value
        ? {
          isActive: true
        } : false
    )

    const onClickReset = () => {
      page.blockingDialog.set({
        title: `Confirmer la suppression`,
        action1: {
          onClick: async () => {
            isLoading.value = true
            await resetSeed()
            location.reload()
          },
          label: `Confirmer`
        },
        action2: {
          onClick: () => {},
          label: `Annuler`
        }
      })
    }

    return {
      onClickReset
    }
  }
}
</script>
